import React, { useEffect, useState } from 'react';
import { Link, useHistory } from 'react-router-dom';
import { SET_AUTH_STATE, SET_CODE_VERIFIER } from 'helpers/types';
import { LoginPageContent } from 'services/content';
import { useDispatch, useSelector } from 'react-redux';
import { NHS_VTR_CODE_P5, NHS_VTR_CODE_P9 } from 'helpers/nhsLogin';
import styles from './style.module.css';
import { AlertMessage, NHSLogo } from 'components';
import hpPromo from 'assets/hey-pharmacist-devices.png';

import useAnalytics from 'hooks/useAnalytics';

const Login = () => {
  const dispatch = useDispatch();
  const crypto = require('crypto');
  const history = useHistory();
  const [challenge, setChallenge] = useState(false);
  const [authState, setAuthState] = useState(false);
  const [postFloodlight] = useAnalytics();
  const [featureEnabled, setFeatureEnabled] = useState(true);
  postFloodlight({ code: 'welco0' });
  const config = useSelector((state) => state.config);

  useEffect(() => {
    const { features } = config;
    if (Object.keys(features).length) {
      setFeatureEnabled(features['nhs_login_only_enabled']);
    }
  }, [config]);

  useEffect(() => {
    function base64URLEncode(str) {
      return str.toString('base64').replace(/\+/g, '-').replace(/\//g, '_').replace(/=/g, '');
    }

    const verifier = base64URLEncode(crypto.randomBytes(32));

    const OAuthState = crypto.randomBytes(32).toString('hex');

    dispatch({ type: SET_CODE_VERIFIER, payload: verifier });
    dispatch({ type: SET_AUTH_STATE, payload: OAuthState });

    function sha256(buffer) {
      return crypto.createHash('sha256').update(buffer).digest();
    }

    setChallenge(base64URLEncode(sha256(verifier)));
    setAuthState(OAuthState);
  }, [crypto, dispatch]);

  return (
    <>
      <div className="coop-l-container">
        <div id="login_page" className={`${styles.login_page} coop-l-medium-12 coop-l-large-12`}>
          <AlertMessage />
          <div className={`${styles.login_grid}`}>
            <div className={`${styles.left_column} drop-shadow coop-l-medium-12 coop-l-large-12`}>
              <h1>{LoginPageContent.headingText}</h1>
              <p className={styles.intro_text}>{LoginPageContent.subHeadingText}</p>

              {challenge && (
                <div className={styles.loginButtonContainer}>
                  <a
                    id="integrationlink"
                    href={
                      window.NHS_URL +
                      '/authorize?client_id=' +
                      window.NHS_CLIENTID +
                      '&response_type=code&scope=openid%20profile%20profile_extended%20gp_integration_credentials%20email%20phone&state=' +
                      authState +
                      '&nonce=456&redirect_uri=' +
                      window.NHS_REDIRECT_URI +
                      '&vtr=' +
                      (window.PROD_FEATURES === 'false' ? NHS_VTR_CODE_P5 : NHS_VTR_CODE_P9) +
                      '&code_challenge_method=S256&code_challenge=' +
                      challenge
                    }>
                    <NHSLogo />
                  </a>
                </div>
              )}
              {!featureEnabled && (
                <>
                  <p className={styles.intro_text}>{LoginPageContent.subHeadingText2}</p>
                  <div className={styles.loginButtonContainer}>
                    <button
                      onClick={() => history.push('/pharmacy/login/email')}
                      className={`coop-btn coop-btn--secondary ${styles.login_button}`}
                      type="button">
                      {LoginPageContent.hpSignInButton}
                    </button>
                  </div>

                  <div className={styles.line_break} />
                </>
              )}
              <p className={styles.link_text}>
                {LoginPageContent.registerPreText}{' '}
                <Link to="/pharmacy/register" className={styles.in_line_link}>
                  {LoginPageContent.registerLinkText}
                </Link>
              </p>
            </div>
            <div className={styles.promo_image}>
              <img src={hpPromo} alt="Hey Pharmacist" />
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;
